<span
  class="s-pt-1 s-pb-1 s-ps-2 s-pe-2 font-weight-bold small-bold d-inline-flex align-items-center rounded"
  [ngClass]="{ yes: value(), no: !value() }"
  (click)="changeStatus()"
>
  <mat-icon class="me-1">
    {{ value() ? "check" : "clear" }}
  </mat-icon>
  {{ value() ? ("yes" | transloco) : ("no" | transloco) }}
</span>
